import { Phone, Mail, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";
import { goToSection } from "@/lib/scroll";
import { CITIES } from "@/pages/CitiesData";

const LINKS = [
  { id: "pour-qui", label: "Pour qui" },
  { id: "pourquoi", label: "Pourquoi" },
  { id: "technologie", label: "Technologie" },
  { id: "deroule", label: "Déroulé" },
  { id: "services", label: "Services" },
  { id: "tarifs", label: "Tarifs" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 bg-night">
      <LogoMark className="pointer-events-none absolute -right-10 -top-16 h-72 w-72 opacity-[0.04]" />
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <img
              src="/logo.webp"
              alt="EDL-EXPRESS — États des lieux immobiliers"
              className="h-12 w-auto"
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Vos états des lieux d'entrée et de sortie, précis, documentés et exploitables —
              partout en Rhône-Alpes.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-cyan-400">
              Navigation
            </p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => goToSection(l.id)}
                    className="text-sm text-slate-300 transition-colors hover:text-cyan-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.24em] text-cyan-400">
              Zones d'intervention
            </p>
            <ul className="mt-4 space-y-2.5">
              {CITIES.map((c) => (
                <li key={c.slug}>
                  <a
                    href={`/etat-des-lieux-${c.slug}`}
                    data-testid={`footer-zone-${c.slug}`}
                    className="text-sm text-slate-300 transition-colors hover:text-cyan-300"
                  >
                    État des lieux à {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-cyan-400">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href="tel:+33622857687"
                  data-testid="footer-phone"
                  className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-cyan-300"
                >
                  <Phone className="h-4 w-4 text-cyan-400" />
                  +33 6 22 85 76 87
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@edl-express.fr"
                  data-testid="footer-email"
                  className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-cyan-300"
                >
                  <Mail className="h-4 w-4 text-cyan-400" />
                  contact@edl-express.fr
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-slate-300">
                <MapPin className="h-4 w-4 text-neon" />
                Secteur Rhône-Alpes
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap gap-x-6 gap-y-2 border-t border-white/10 pt-6">
          {[
            { href: "/mentions-legales", label: "Mentions légales" },
            { href: "/confidentialite", label: "Politique de confidentialité" },
            { href: "/cgv", label: "Conditions générales de vente" },
          ].map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-legal-${l.href.replace("/", "")}`}
              className="text-xs text-slate-400 transition-colors hover:text-cyan-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-2 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} EDL-EXPRESS — Tous droits réservés</p>
          <p className="font-mono uppercase tracking-[0.18em]">
            États des lieux d'entrée & de sortie — Rhône-Alpes
          </p>
        </div>
      </div>
    </footer>
  );
}
